import {uiMsg} from '../utils/Languages';
import React, {Component} from 'react';
import {observer} from 'mobx-react';
import Paper from 'material-ui/Paper';
import { Link } from 'react-router';

let pageStyle = {
  margin:"1em",
};

let headerStyle = {
  fontFamily: "Roboto, sans-serif",
  fontSize: "20px",
  fontWeight: "400",
  height: "48px",
  lineHeight: "48px"
}

export default
@observer class SupportInfo extends Component {
  render() {
    return (
      <div style={pageStyle}>
        <h2 style={headerStyle}>{uiMsg('SI_CONTACT_US',"Contact us")}</h2>
          <b>{uiMsg('SI_PHONE',"Telephone")}</b>:
            <span dangerouslySetInnerHTML={{__html:uiMsg('SI_PHONE_HOURS',"(+47) 22 16 51 60 (Monday-Friday 08:00-16:00)")}} />            
            <br></br>
          <b>{uiMsg('SI_EMAIL_LABEL',"Email")}:</b> <a href="mailto:support@deconx.com">support@deconx.com</a>
      </div>
    );
  }

};



/** WEBPACK FOOTER **
 ** ./src/pages/SupportInfoPage.jsx
 **/